import script from "./ReceitasFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasFormView.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasFormView.vue?vue&type=style&index=0&id=4c699d1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c699d1d"]])

export default __exports__